<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-lg-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col-lg-3" style="margin-top:20px;margin-bottom:20px">
            <span>{{$t('start_date')}}</span> <base-input style="padding-top: 1rem;margin-bottom: 0rem;" addon-left-icon="ni ni-calendar-grid-58">
                <flat-picker slot-scope="{focus, blur}"
                            @on-close="blur, ChangeDate()"
                            :config="config"
                            class="form-control datepicker"
                            v-model="start_date">
                </flat-picker>
            </base-input>
        </div>
        <div class="col-lg-3" style="margin-top:20px;margin-bottom:20px">
            <span>{{$t('end_date')}}</span> <base-input style="padding-top: 1rem;margin-bottom: 0rem;" addon-left-icon="ni ni-calendar-grid-58">
                <flat-picker slot-scope="{focus, blur}"
                            @on-close="blur, ChangeDate()"
                            :config="config"
                            class="form-control datepicker"
                            v-model="end_date">
                </flat-picker>
            </base-input>
        </div>
        <div class="col-lg-3" style="margin-top:20px;margin-bottom:20px">
            <span>{{$t('type_billing')}}</span><br />
            <base-dropdown style="margin-top:14px">
                <base-button slot="title" type="secondary" class="dropdown-toggle">
                <div style="display:inline" v-if="type_billing!==''">{{$t(type_billing)}}</div>
                <div style="display:inline" v-if="type_billing===''">{{$t('all')}}</div>
                </base-button>
                <a class="dropdown-item" @click="type_billing='', ChangeType()" href="#">{{$t('all')}}</a>
                <a class="dropdown-item" @click="type_billing='onetime', ChangeType()" href="#">{{$t('onetime')}}</a>
                <a class="dropdown-item" @click="type_billing='weekly', ChangeType()" href="#">{{$t('weekly')}}</a>
                <a class="dropdown-item" @click="type_billing='monthly', ChangeType()" href="#">{{$t('monthly')}}</a>
                <a class="dropdown-item" @click="type_billing='yearly', ChangeType()" href="#">{{$t('yearly')}}</a>
            </base-dropdown>
        </div>
      </div>
    </div>

    <div class="table-responsive">

      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="show_item">
        <template slot="columns">
          <th>{{$t('first_name')}} {{$t('last_name')}}</th>
          <th>{{$t('nickname')}}</th>
          <th>{{$t('phone')}}</th>
          <th>{{$t('type_billing')}}</th>
          <th>{{$t('amount')}}</th>
          <th>{{$t('charge_date')}}</th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                  <span style="color:#525f7f" class="name mb-0 text-sm">{{row.member.firstname}} {{row.member.lastname}}</span>
              </div>
            </div>
          </th>
          <td>
              <span style="color:#525f7f">{{row.member.nickname}}</span>
          </td>
          <td>
              <span style="color:#525f7f">{{row.member.phone}}</span>
          </td>
          <td>
              <span v-if="row.type === 'onetime'" style="color:#525f7f">{{$t('onetime')}}</span>
              <span v-if="row.type === 'weekly'" style="color:#525f7f">{{$t('weekly')}}</span>
              <span v-if="row.type === 'monthly'" style="color:#525f7f">{{$t('monthly')}}</span>
              <span v-if="row.type === 'yearly'" style="color:#525f7f">{{$t('yearly')}}</span>
          </td>
          <td>
              <span style="color:#525f7f">{{row.amount}}</span>
          </td>
          <td>
              <span style="color:#525f7f">{{ row.charge_date | luxon }}</span>
          </td>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
         <div @click="ListItem()">
            <base-pagination v-model="page" :perPage="show_page.limit" :total="show_page.total" :pageCount="show_page.total" size="lg"></base-pagination>
        </div>
    </div>

    <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>

  </div>
</template>
<script>
var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000)
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
  export default {
    name: 'billing-table',
    components: {flatPicker},
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        show_item: [],
        show_page: [],
        id: this.$route.query.id,
        start_date : new Date(beforeOneWeek).toISOString(),
        end_date : new Date().toISOString(),
        limit: 10,
        page: 1,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'j M, Y',
          altInput: true,
          dateFormat: 'Y-m-d'
        },
        type_billing: ''
      }
    },
    computed: {
      rows() {
          return this.show_item.length
      }
    },
    created () {
      this.ListItem()
    },
    watch: {
        '$route': function(){
          this.id = this.$route.query.id,
          setTimeout(() => {
            this.ListItem();
          }, 100)
        }
    },
    methods: {
      modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
      },
      ChangeDate () {
        this.page = 1
          setTimeout(() => {
            this.ListItem();
          }, 100)
      },
      ChangeType () {
        this.page = 1
          setTimeout(() => {
            this.ListItem();
          }, 100)
      },
      ListItem () {
        if (this.id === undefined) {
          this.id = ''
        }
        this.show_item = []
        this.page = this.page-1
        this.$http.get('gyms/billing?limit='+this.limit+'&page='+this.page+'&start_date='+this.start_date+'&end_date='+this.end_date+'&type='+this.type_billing)
          .then(request => this.ListItemSuccessful(request))
          .catch(() => this.ListItemFailed())
        this.page = this.page+1
      },
      ListItemSuccessful (req) {
        if (req.data.code !== '0') {
          this.ListItemFailed(req)
          return
        }
        for (var i = 0, l = req.data.data.data.length; i < l; i++) {
          this.show_item.push(req.data.data.data[i])
          if(req.data.data.data[i].member.photo === undefined) {
            this.show_item[i].member.photo = ''
          }
        }
        this.show_page = req.data.data.pagination
      },
      ListItemFailed (req) {
        this.modalAlert(req)
      }
    }
  }
</script>
<style>
</style>
